
// Estilos
import estilos from './pageWork.module.css';

// Componentes
import Background from "../../elements/backgrounds/background";
import LabelMenu from '../../elements/labels/labelMenu';

function PageWork(){
    return (
        <main>
            <Background>
                <LabelMenu opcion='work' goBack={true}/>
                <p id={estilos.text}>
                    We've done a lot.
                    <br/>
                    We just haven't put it here yet.
                    <br/>
                    (Vamos, que el programador está liao)
                </p>
            </Background>
        </main>
    )
}

export default PageWork;